import { mutation_keys } from "../mutations";

/**
 * App action keys.
 * @type {import("../types/actions/app").AppActionKeys}
 */
const app_action_keys = {
    "START_LOADING": "APP/START_LOADING",
    "STOP_LOADING": "APP/STOP_LOADING"
}

/**
 * App specific actions.
 * @type {import("../types/actions/app").AppActions}
 */
const app_actions = {
    /** Loading application. */
    [app_action_keys.START_LOADING]: ({ commit }) => commit(mutation_keys.app.SET_LOADING_STATUS, true),
    /** Stop loading application. */
    [app_action_keys.STOP_LOADING]: ({ commit }) => commit(mutation_keys.app.SET_LOADING_STATUS, false)
};

export { app_action_keys };

export default app_actions;